<template>
    <v-dialog fullscreen persistent v-model="showDialog" transition="dialog-bottom-transition">
        <v-card>
            <v-container>
                <v-layout row wrap>
                    <v-flex xs12 class="mt-3">
                        <h3 class="display-1 grey--text text--darken-2 text-xs-center">Timesheet Disclaimer</h3>
                        <v-divider></v-divider>
                            <v-btn @click="translateDialog = true" block depressed class="blue lighten-2 white--text"><v-icon left>translate</v-icon>{{disclaimerLanguage}}</v-btn>
                        <p class="mt-3" v-html="disclaimerText"></p>
                    </v-flex>
                    <v-flex xs12 class="mt-3" v-if="!disclaimerAccepted">
                        <v-layout row wrap>
                            <v-flex xs12>
                                <p class="red--text text-xs-center mb-0"><b>This disclaimer must be accepted before you can clock in.</b></p>
                            </v-flex>
                            <v-flex xs8>
                                <v-btn block class="success" @click="acceptDisclaimer">Accept</v-btn>
                            </v-flex>
                            <v-flex offset-xs1 xs3>
                                <v-btn block class="error" @click="declineDisclaimer">Decline</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 v-else>
                        <p class="green--text text-xs-center mb-0"><b>You've already accepted the disclaimer.</b></p>
                        <v-btn block class="grey darken-1 white--text" @click="hideDisclaimer">Close</v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>
      <v-dialog v-model="translateDialog">
        <v-card>
          <v-card-title><h3 class="title">Disclaimer Language</h3></v-card-title>
            <v-list>
                <v-list-tile avatar v-for="language in languages" :key="language" @click="selectLanguage(language)">
                    <span class="body-1">{{language}}</span>
                </v-list-tile>
            </v-list>
        </v-card>
      </v-dialog>
    </v-dialog>
</template>

<script>
  export default {
    props: ['showDialog'],
    data () {
      return {
        translateDialog: false
      }
    },
    computed: {
      disclaimerText () {
        return this.$store.getters.disclaimerText
      },
      disclaimerAccepted () {
        return this.$store.getters.disclaimerAccepted
      },
      disclaimerLanguage () {
        return this.$store.getters.disclaimerLanguage
      },
      languages () {
        return this.$store.getters.languages
      }
    },
    created () {
      this.disclaimerDialog = this.showDialog
    },
    watch: {
      showDialog: function (val) {
        this.$store.dispatch('checkLoginTime')
      }
    },
    methods: {
      acceptDisclaimer () {
        this.$emit('update:showDialog', false)
        this.$store.dispatch('acceptDisclaimer')
      },
      declineDisclaimer () {
        this.$emit('update:showDialog', false)
        this.$emit('declined')
      },
      hideDisclaimer () {
        this.$emit('update:showDialog', false)
      },
      selectLanguage (newLanguage) {
        this.$store.dispatch('setDisclaimerLanguage', newLanguage)
        this.translateDialog = false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/DisclaimerDialog.vue